interface HeroSectionProps {
  scrollToSection: () => void;
}

export default function HeroSection({ scrollToSection }: HeroSectionProps) {
  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden" aria-label="首屏焦点">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20dramatic%20abstract%20grunge%20texture%20with%20crimson%20red%20light%20streaks%20and%20smoke%20effects%2C%20deep%20black%20background%20with%20subtle%20newsroom%20vibe%2C%20mysterious%20investigative%20journalism%20aesthetic%2C%20cinematic%20atmosphere%2C%20low%20key%20lighting%2C%20editorial%20dark%20photography%20with%20dramatic%20contrast%2C%20no%20text%2C%20abstract%20composition&width=1920&height=1080&seq=hero-bg-main-01&orientation=landscape"
          alt="911爆料网背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-background-50"></div>
      </div>

      <div className="relative z-10 w-full flex flex-col items-center text-center px-4 pt-20">
        <div className="max-w-4xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-accent-500/30 bg-accent-500/10 mb-8">
            <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
            <span className="text-xs text-accent-300 font-medium tracking-wider">实时追踪 · 每5分钟更新</span>
          </div>

          <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading text-foreground-50 leading-tight mb-4">
            全网最新
            <br />
            吃瓜爆料
          </h1>

          <p className="text-base md:text-lg text-foreground-400 max-w-xl mx-auto leading-relaxed mb-10">
            网红黑料、明星八卦、社会奇闻，每日实时更新。
            <br className="hidden md:block" />
            一手黑料视频，让您不错过任何一个大瓜。
          </p>

          <button
            onClick={scrollToSection}
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-foreground-50 text-base font-medium rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap dark:text-foreground-950 group"
          >
            立即开吃瓜
            <i className="ri-arrow-down-line text-lg w-5 h-5 flex items-center justify-center group-hover:translate-y-0.5 transition-transform"></i>
          </button>
        </div>

        <div className="mt-16 md:mt-20 w-full max-w-6xl mx-auto px-4">
          <div className="relative rounded-2xl overflow-hidden aspect-video md:aspect-[21/9]">
            <img
              src="https://readdy.ai/api/search-image?query=Dark%20mysterious%20newsroom%20aesthetic%20with%20blurred%20screens%20showing%20social%20media%20feeds%2C%20deep%20shadows%2C%20red%20accent%20glow%20from%20monitors%2C%20investigative%20journalism%20vibe%2C%20cinematic%20atmosphere%2C%20noir%20style%2C%20dramatic%20composition%2C%20low%20key%20lighting%2C%20moody%20and%20mysterious%20editorial%20photography&width=1920&height=800&seq=hero-banner-02&orientation=landscape"
              alt="911爆料 - 最新吃瓜资讯"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-background-50/80 via-transparent to-transparent rounded-2xl"></div>
            <div className="absolute bottom-6 left-6 right-6 flex items-center gap-4 flex-wrap">
              <span className="px-3 py-1 bg-primary-500/90 text-foreground-50 text-xs font-medium rounded-full whitespace-nowrap dark:text-foreground-950">
                独家爆料
              </span>
              <span className="text-sm text-foreground-200 font-medium line-clamp-1">
                某千万粉丝女主播被曝私下与榜一大哥约会
              </span>
            </div>
          </div>
        </div>

        <div className="mt-8 flex items-center gap-3 text-foreground-500">
          <span className="text-xs">向下滚动查看更多</span>
          <i className="ri-mouse-line text-lg w-5 h-5 flex items-center justify-center animate-bounce"></i>
        </div>
      </div>
    </section>
  );
}